import React, { useState } from "react";
import { supabase } from "../../supabaseClient";
import { useAuth } from "../../context/UserContext";
import { Link } from "react-router-dom";

export const Profileinfo = () => {
    const { user } = useAuth();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
    const handleSignOut = async () => {
      await supabase.auth.signOut();
    };
  
    const toggleDropdown = () => {
      setIsDropdownOpen(!isDropdownOpen);
    };
  return (
    <> 
         <header className="flex justify-end items-center mb-6">
          {user && (
            <div className="relative">
              <button
                className="flex items-center"
                onClick={toggleDropdown}
              >
                <img
                  className="w-10 h-10 rounded-full"
                  src={user.user_metadata.picture}
                  alt="Profile"
                />
                <h6 className="ml-3 text-gray-700 font-medium">
                  {user.user_metadata.full_name}
                </h6>
              </button>
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg">
                  <button 
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <Link to="/account">Account</Link>
                  </button>
                  <button
                    onClick={handleSignOut}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </button>
                  
                </div>
              )}
            </div>
          )}
        </header>
    </>
  )
}
